import { render, staticRenderFns } from "./NewBannerCarousel.vue?vue&type=template&id=66e498df&scoped=true&"
import script from "./NewBannerCarousel.vue?vue&type=script&lang=js&"
export * from "./NewBannerCarousel.vue?vue&type=script&lang=js&"
import style0 from "./NewBannerCarousel.vue?vue&type=style&index=0&id=66e498df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e498df",
  null
  
)

export default component.exports